var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"write"},[_vm._v("请使用微信扫描二维码签到")]),_c('van-image',{attrs:{"width":"200","height":"200","src":_vm.realUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }